import { createSlice } from '@reduxjs/toolkit';
import { CustomerCollectionView } from '@dill/dill-shared';
import {
  getCustomerCollectionViewsExtraReducer,
  createCustomerCollectionViewExtraReducer,
  updateCustomerCollectionViewExtraReducer,
  deleteCustomerCollectionViewExtraReducer,
} from '../reducers/customerCollectionViewsReducers';

export interface CustomerCollectionViewsInitialState {
  loadingList: string[];
  error: string | null;
  views: CustomerCollectionView[];
}

const initialState: CustomerCollectionViewsInitialState = {
  loadingList: [],
  error: null,
  views: [],
};

export const customerCollectionViewsSlice = createSlice({
  name: 'customerCollectionViews',
  initialState,
  reducers: {
    resetCustomerCollectionViewsRootState: () => initialState,
  },
  extraReducers(builder) {
    getCustomerCollectionViewsExtraReducer(builder);
    createCustomerCollectionViewExtraReducer(builder);
    updateCustomerCollectionViewExtraReducer(builder);
    deleteCustomerCollectionViewExtraReducer(builder);
  },
});

export const { resetCustomerCollectionViewsRootState } = customerCollectionViewsSlice.actions;
